import { GiTaskCategory, GiTaskCategoryJson } from '@gi/models/gi-task-category';

export interface LegalStructureGiTaskCategoryJson {
  id: number;
  gi_task_category: GiTaskCategoryJson;
}

export class LegalStructureGiTaskCategory {
  constructor(
    public id?: number,
    public giTaskCategory?: GiTaskCategory
  ) {}

  static fromJson(json: LegalStructureGiTaskCategoryJson): LegalStructureGiTaskCategory {
    return new LegalStructureGiTaskCategory(
      json.id,
      json.gi_task_category ? GiTaskCategory.fromJson(json.gi_task_category) : undefined
    );
  }

  static toJson(legalStructureGiTaskCategory: LegalStructureGiTaskCategory): LegalStructureGiTaskCategoryJson {
    return {
      id: legalStructureGiTaskCategory.id ?? undefined,
      gi_task_category: legalStructureGiTaskCategory.giTaskCategory
        ? GiTaskCategory.toJson(legalStructureGiTaskCategory.giTaskCategory)
        : undefined
    };
  }
}
